/** LaunchDarkly-style DB feature flag key for the Manager Operating System. */
export const MANAGER_OPERATING_SYSTEM_FEATURE_FLAG =
  'manager-operating-system';

/** Root path for the Manager Operating System application shell. */
export const MANAGER_OPERATING_SYSTEM_PREFIX_PATH =
  '/manager-operating-system';

/** Your Guides MOS landing path. */
export const MANAGER_OPERATING_SYSTEM_YOUR_GUIDES_PATH = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/your-guides`;

/** Team Workflow MOS path. */
export const MANAGER_OPERATING_SYSTEM_TEAM_WORKFLOW_PATH = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/team-workflow`;

/** Single guide MOS detail path prefix. */
export const MANAGER_OPERATING_SYSTEM_GUIDE_PATH_PREFIX = `${MANAGER_OPERATING_SYSTEM_PREFIX_PATH}/guide`;
